import { render, staticRenderFns } from "./supplierBidDetailsNew2.vue?vue&type=template&id=7c587085&scoped=true"
import script from "./supplierBidDetailsNew2.vue?vue&type=script&lang=js"
export * from "./supplierBidDetailsNew2.vue?vue&type=script&lang=js"
import style0 from "./supplierBidDetailsNew2.vue?vue&type=style&index=0&id=7c587085&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c587085",
  null
  
)

export default component.exports